import React from 'react';
import { FaDownload } from 'react-icons/fa';
import { file as filePropType } from './proptypes';

const propTypes = {
    file: filePropType.isRequired,
};

const defaultProps = {};

function ClinicalNoteLink({ file }) {
    return (
        <a
            data-testid="clinical-note-link"
            target="_blank"
            href={`/stm/download_note_file.php?file_id=${file.id}`}
            rel="noopener noreferrer"
        >
            <span className="file-name"> {file.origFileName} </span>
            <span className="file-icon">
                <FaDownload />
            </span>
        </a>
    );
}

ClinicalNoteLink.propTypes = propTypes;
ClinicalNoteLink.defaultProps = defaultProps;

export default ClinicalNoteLink;
